const changePage = (set) => (page) => {
  set({ page });
};

export default changePage;
